import { Avatar, type AvatarProps } from '@mui/material';
import { forwardRef, type SyntheticEvent } from 'react';
import { useOptionalAvatarImage } from '~/shared/hooks/useOptionalAvatarImage';
import { getInitials } from '~/shared/utils/initials';

export interface Props extends Omit<AvatarProps, 'src' | 'children'> {
  avatarUrl?: string | null;
  /** Used for initials; default `alt` when `alt` is not passed */
  initialsLabel: string;
}

export const AvatarImage = forwardRef<HTMLDivElement, Props>(
  function AvatarImage(
    { avatarUrl, initialsLabel, alt, imgProps: imgPropsFromParent, ...rest },
    ref,
  ) {
    const { src, imgProps: hookImgProps } = useOptionalAvatarImage(avatarUrl);

    const mergedImgProps = {
      ...hookImgProps,
      ...imgPropsFromParent,
      onError: (event: SyntheticEvent<HTMLImageElement>) => {
        hookImgProps.onError();
        imgPropsFromParent?.onError?.(event);
      },
    };

    return (
      <Avatar
        ref={ref}
        src={src}
        imgProps={mergedImgProps}
        alt={alt === undefined ? initialsLabel : alt}
        {...rest}
      >
        {getInitials(initialsLabel)}
      </Avatar>
    );
  },
);
